import script from "./navigation-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./navigation-bar.vue?vue&type=script&lang=ts&setup=true"

import "./navigation-bar.vue?vue&type=style&index=0&id=7d4d52ca&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4d52ca"]])

export default __exports__